import { confirmResetPassword, resetPassword } from '@aws-amplify/auth';
import { ofType } from 'redux-observable';
import { of, merge } from 'rxjs';
import { mergeMap, switchMap, catchError } from 'rxjs/operators';

import {
	requestResetCode,
	requestResetCodeCompleted,
	requestResetCodeFailed,
	resetUserPassword,
	resetUserPasswordCompleted,
	resetUserPasswordFailed
} from './forgottenPasswordSlice';

export const requestResetCodeEpic = (action$) =>
	action$.pipe(
		ofType(requestResetCode.type),
		mergeMap(async (action) => {
			const { username } = action.payload;

			await resetPassword(username);
		}),
		switchMap((res) => [requestResetCodeCompleted(res)]),
		catchError((error, source) =>
			merge(of(requestResetCodeFailed(error.message)), source)
		)
	);

export const submitResetPasswordEpic = (action$, state$) =>
	action$.pipe(
		ofType(resetUserPassword.type),
		mergeMap(async (action) => {
			const username = state$.value.forgottenPasswordReducer.get('username');
			const { verificationCode, newPassword } = action.payload;

			const confirmationCode = verificationCode;

			await confirmResetPassword(username, confirmationCode, newPassword);
		}),
		switchMap((res) => [resetUserPasswordCompleted(res)]),
		catchError((error, source) =>
			merge(of(resetUserPasswordFailed(error.message)), source)
		)
	);

export default [requestResetCodeEpic, submitResetPasswordEpic];
